import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/image/no_data1.png'


const _hoisted_1 = {
  key: 0,
  class: "ckb-choice-list"
}
const _hoisted_2 = { class: "ckb-choice-title" }
const _hoisted_3 = {
  style: {"width":"1296px","margin":"auto"},
  class: "flex-ter-bwn"
}
const _hoisted_4 = { class: "ckb-choice-logo fx-1" }
const _hoisted_5 = { class: "title line--only" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "ckb-choice-btn" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/choice/logo_bg.png" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/choice/like.png" }, null, -1)
const _hoisted_10 = { class: "ckb-choice-content" }
const _hoisted_11 = {
  key: 0,
  class: "choice-filter"
}
const _hoisted_12 = {
  key: 0,
  class: "prop line--only"
}
const _hoisted_13 = { style: {"max-width":"150px","font-size":"14px"} }
const _hoisted_14 = { class: "prop line--only" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "label-text rel line--only" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "label-text rel line--only"
}
const _hoisted_19 = { style: {"max-width":"150px","font-size":"14px"} }
const _hoisted_20 = { class: "label-text rel line--only" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex-center" }
const _hoisted_23 = { class: "label-item" }
const _hoisted_24 = { class: "rel flex" }
const _hoisted_25 = { class: "prop line--only" }
const _hoisted_26 = { class: "flex-wrap label-values" }
const _hoisted_27 = { class: "value flex-ter" }
const _hoisted_28 = {
  key: 1,
  class: "choice-product-list"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "product-img" }
const _hoisted_31 = { class: "img-list flex-ter" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/like_img.png",
  alt: ""
}
const _hoisted_34 = {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/un_like_img.png",
  alt: ""
}
const _hoisted_35 = { class: "product-name" }
const _hoisted_36 = { class: "product-btn" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "build-btn"
}
const _hoisted_39 = {
  key: 2,
  class: "noResult flex-col flex-ter"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  class: "no_data1",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_41 = { class: "tips" }
const _hoisted_42 = { class: "page" }
const _hoisted_43 = {
  key: 1,
  class: "text-ct code-error"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  class: "no-data-code-error",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text-ct" }, "このページではアクセスがサポートされていません。", -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 2,
  class: "ckb-choice-nologin flex-center"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/clock.png",
  alt: ""
}, null, -1)
const _hoisted_49 = { class: "text" }

import { openShareLinkDetailApi, getTagListApi, addWishListApi, removeWishListApi } from '@/apis/goods'
import { t } from '@/plugins/i18n'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Pagination from '@/components/common/pagination/index.vue'
import { useStore } from 'vuex'
import { ElMessage as message } from 'element-plus'
import { ArrowUpBold } from '@element-plus/icons-vue'
import { useRtfix } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const visible = ref(false)
const router = useRouter()
const route = useRoute()
const password = ref('')
const canBuyFlag = ref(false)
const isCodeError = ref(false)
const title = ref('')
const pageInfo = ref({
  current: 1,
  pageSize: 15,
  total: 0
})
const paginationConfig = {
  layout: ' prev, pager, next '
}
const currentPage = computed({
  get() {
    return {
      page: pageInfo.value.current,
      limit: pageInfo.value.pageSize
    }
  },
  set(v: any) {
    const { page, limit } = v
    pageInfo.value.current = page
    getList()
  }
})
watch(canBuyFlag, () => {
  pageInfo.value.current = 1
  getList()
})
// 标签
const tags: any = ref([])
const productList: any = ref([])
const cancel = () => {
  visible.value = false
}
const toBuy = (productCode: string) => {
  router.push(useRtfix('goods', { params: { id: productCode } }))
}
const jumpChoiceDetail = (item: { atlasCode: string }) => {
  router.push(useRtfix('ckbDetail', { params: { code: item.atlasCode }, query: { haveLink: 1 } }))
}
const getList = async () => {
  const tagIds = tags.value.map(v => v.status).filter(v => v !== 0)
  openShareLinkDetailApi({
    shareCode: route.params.code,
    pageNo: pageInfo.value.current,
    pageSize: pageInfo.value.pageSize,
    canBuyFlag: canBuyFlag.value ? 1 : undefined,
    labelIds: tagIds,
    superCustomerId: store.getters.user?.superCustomerId,
    customerShopId: store.state.route.curShop
  }).then(({ data, success, code }) => {
    if (!success) {
      console.log('aaa', code)
      isCodeError.value = true
      return
    }
    title.value = data.title
    pageInfo.value.total = data.page.total
    productList.value = data.page.records
  }).catch((error) => {
    console.log('error', error)
  })
}
const changeTag = (index: number, status: number) => {
  tags.value[index].status = status
  pageInfo.value.current = 1
  getList()
}
const changeCheckbox = () => {
}
onMounted(async () => {
  if (!store.getters.isLogin) {
    return
  }
  const { data } = await getTagListApi({
    openStatus: 1
  })
  tags.value = data.filter(v => v.children.length > 0).map(v => ({
    ...v,
    status: 0
  }))
  getList()
})

const updateCollect = async (item: { addWishFlag: number, atlasCode: string }) => {
  const api = item.addWishFlag === 0 ? addWishListApi : removeWishListApi
  const { success } = await api({
    atlasCode: item.atlasCode
  })
  if (success) {
    message.success(item.addWishFlag === 0 ? t('加入心愿单成功！') : t('成功取消添加心愿单'))
    getList()
  }
}
const jumpLogin = () => {
  router.push('/login?redirect=' + encodeURIComponent(window.location.href))
}

// 展开筛选
const isExtra = ref(true)
const slice = 2

// 每行dom高度
const itemHeight = reactive<(number | string)[]>([])

const setHeight = (el: HTMLElement, i: number) => {
  itemHeight[i] = el?.getBoundingClientRect().height ?? ''
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(store).getters.isLogin && !isCodeError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(title.value), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('CKB对于高级会员一对一定制化选品提案。将喜欢的商品加入心愿清单，CKB会为您快速创建商品。')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", {
                class: "add-btn flex-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('CollectProduct', { query: { tab: '3' } }))))
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('我的心愿单')), 1),
                _hoisted_9
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (v, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: v.label,
                    class: _normalizeClass(["label-item", {
          hidden: i > slice && !isExtra.value,
          'hide-border': i === slice && !isExtra.value,
          collapse: !v.expand,
        }]),
                    style: _normalizeStyle({ height: _unref(itemHeight)[i] ? _unref(itemHeight)[i] + 'px' : 'auto' })
                  }, [
                    _createElementVNode("div", {
                      class: "rel flex",
                      ref: (el) => setHeight(el as HTMLElement, i)
                    }, [
                      (v.labelNameJp?.length < 11)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(v.labelNameJp), 1))
                        : (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 1,
                            effect: "light",
                            placement: "top",
                            "popper-class": "tool-tip-no-border"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(v.labelNameJp), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, _toDisplayString(v.labelNameJp), 1)
                            ]),
                            _: 2
                          }, 1024)),
                      _createElementVNode("div", {
                        class: "flex-wrap label-values",
                        style: _normalizeStyle({ overflow: (i < 4) && v.expand ? 'auto' : 'hidden' })
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["value flex-ter", { active: v.status === 0 }]),
                          onClick: ($event: any) => (changeTag(i, 0))
                        }, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('全部')), 1)
                        ], 10, _hoisted_15),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.children, (opt) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["value flex-ter", { active: v.status === opt.labelId }]),
                            key: opt.label,
                            onClick: ($event: any) => (changeTag(i, opt.labelId))
                          }, [
                            (opt.labelNameJp?.length < 11)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(opt.labelNameJp), 1))
                              : (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 1,
                                  effect: "light",
                                  placement: "top",
                                  "popper-class": "tool-tip-no-border"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(opt.labelNameJp), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_20, _toDisplayString(opt.labelNameJp), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ], 10, _hoisted_17))
                        }), 128))
                      ], 4),
                      (Number(_unref(itemHeight)[i]) > 40)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "abs expand",
                            style: {"right":"20px"},
                            onClick: ($event: any) => (v.expand = !v.expand)
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)(v.expand ? '收起' : '展开')), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["icon", { rotate: v.expand }])
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowUpBold))
                                  ]),
                                  _: 1
                                })
                              ], 2)
                            ])
                          ], 8, _hoisted_21))
                        : _createCommentVNode("", true)
                    ], 512)
                  ], 6))
                }), 128)),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('可购买')), 1),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_el_checkbox, {
                          onChange: changeCheckbox,
                          modelValue: canBuyFlag.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((canBuyFlag).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('当前可购买')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (productList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "product-item",
                    key: item.id,
                    onClick: ($event: any) => (jumpChoiceDetail(item))
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", {
                        class: "good-img-content flex-center",
                        style: _normalizeStyle({ backgroundImage: `url(${item.headerImage + (item.headerImage.includes('theckb') ? `?x-oss-process=image/resize,w_${800},limit_0,/format,webp` : '')})` })
                      }, null, 4),
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.productImgs, (temp, k) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                            (k < 5)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "img-list-item flex-center",
                                  style: _normalizeStyle({ backgroundImage: `url(${temp + (temp.includes('theckb') ? `?x-oss-process=image/resize,w_${200},limit_0,/format,webp` : '')})` })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]),
                      _createElementVNode("div", {
                        class: "collect-btn",
                        onClick: _withModifiers(($event: any) => (updateCollect(item)), ["stop"])
                      }, [
                        _withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [
                          [_vShow, item.addWishFlag === 1]
                        ]),
                        _withDirectives(_createElementVNode("img", _hoisted_34, null, 512), [
                          [_vShow, item.addWishFlag !== 1]
                        ])
                      ], 8, _hoisted_32)
                    ]),
                    _createElementVNode("div", _hoisted_35, "PRODUCT#" + _toDisplayString(item.atlasCode), 1),
                    _createElementVNode("div", _hoisted_36, [
                      (item.productCode)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "buy-btn",
                            onClick: _withModifiers(($event: any) => (toBuy(item.productCode)), ["stop"])
                          }, _toDisplayString(_unref(t)('立即购买')), 9, _hoisted_37))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(t)('采购链接制作中')) + "...", 1))
                    ])
                  ], 8, _hoisted_29))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('暂无数据')), 1)
              ])),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(Pagination, {
              className: "flex-center",
              showPagination: true,
              total: pageInfo.value.total,
              "page-data": _unref(currentPage),
              "onUpdate:page-data": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : null)),
              paginationConfig: paginationConfig
            }, null, 8, ["total", "page-data"])
          ])
        ])
      ]))
    : (isCodeError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(t)('登录后可查看内容，请先登录！')), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              class: "btn",
              type: "primary",
              onClick: jumpLogin
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('立即登录')), 1)
              ]),
              _: 1
            })
          ])
        ]))
}
}

})